export default __webpack_public_path__ + "49e20dfc2670a6fe3dd586cd513ab8ad.svg";